import { proxy } from 'valtio';
import { FuiUserAvatar } from '../heineken_template/components/FuiUserAvatar';
export const fubon_store = proxy({
    userAvatar: new FuiUserAvatar(),
    levelValue: NaN,
    cost240Value: NaN,
    cost60Value: NaN,
});
